import { render, staticRenderFns } from "./ChatOrderModalAddProduct.vue?vue&type=template&id=4f62c989&scoped=true&"
import script from "./ChatOrderModalAddProduct.vue?vue&type=script&lang=js&"
export * from "./ChatOrderModalAddProduct.vue?vue&type=script&lang=js&"
import style0 from "./ChatOrderModalAddProduct.vue?vue&type=style&index=0&id=4f62c989&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f62c989",
  null
  
)

export default component.exports